export { default } from './Payments'